module.exports = __webpack_public_path__ + "img/w3_sort_light.c0484ea0.png";